// API服务工具函数

// 根据环境设置API基础URL
const API_BASE_URL = import.meta.env.PROD ? '' : '/api';
// 注意：在生产环境中使用相对路径，由Nginx代理到后端
// 在开发环境中，Vite代理会处理API请求

// 获取网站公开配置
export const getSiteConfig = async () => {
  try {
    const response = await fetch('/api/admin/config/public', {
      headers: {
        'Cache-Control': 'no-cache, no-store, must-revalidate',
        'Pragma': 'no-cache',
        'Expires': '0'
      }
    });
    if (!response.ok) {
      throw new Error(`HTTP error! status: ${response.status}`);
    }
    const data = await response.json();
    if (data.success) {
      return data.data;
    } else {
      throw new Error(data.message || '获取配置失败');
    }
  } catch (error) {
    console.error('获取网站配置失败:', error);
    // 返回默认配置
    return {
      identity: {
        site_name: '无锡市摩恒科技有限公司',
        logo_pc: '/uploads/logo/logo-pc.png',
        logo_mobile: '/uploads/logo/logo-mobile.png',
        footer_logo_pc: '/uploads/logo/footer-logo-pc.png',
        footer_logo_mobile: '/uploads/logo/footer-logo-mobile.png',
        favicon: '/uploads/logo/favicon.ico',
        site_domain: 'www.wxmhkj.cn',
        ssl_certificate: 'wxmhkj.cn',
        ssl_expiry_date: '2025-12-31'
      },
      copyright: {
        copyright_text: '© 2025 无锡市摩恒科技有限公司 版权所有',
        icp_number: '苏ICP备XXXXXX号',
        police_record_number: '苏公网安备 XXXXXXXX号',
        icp_link: 'https://beian.miit.gov.cn',
        police_record_link: 'http://www.beian.gov.cn',
        icp_icon: '/uploads/logo/icp-icon.png',
        police_icon: '/uploads/logo/police-icon.png',
        show_icp: true,
        show_police: true
      },
      site: {
        name: '无锡市摩恒科技有限公司',
        description: '专业科技解决方案提供商',
        keywords: '科技,解决方案,无锡,摩恒',
        contact_email: 'info@mohengtech.com',
        contact_phone: '0510-XXXXXXX',
        company_address: '江苏省无锡市'
      },
      company_stats: {
        founded_year: '2015',
        patents: '20+',
        area: '2000平',
        registered_capital: '1000万',
        employees: '50+',
        rd_team: '15人'
      }
    };
  }
};

// 获取格式化后的网站配置（为了向后兼容，保留此函数）
export const getFormattedSiteConfig = async () => {
  return await getSiteConfig();
};

// 通用GET请求
export const apiGet = async (endpoint, token = null) => {
  const headers = {
    'Content-Type': 'application/json',
  };
  
  if (token) {
    headers['Authorization'] = `Bearer ${token}`;
  }
  
  const response = await fetch(`${API_BASE_URL}${endpoint}`, {
    method: 'GET',
    headers,
  });
  
  if (!response.ok) {
    throw new Error(`HTTP error! status: ${response.status}`);
  }
  
  return response.json();
};

// 通用POST请求
export const apiPost = async (endpoint, data, token = null) => {
  const headers = {
    'Content-Type': 'application/json',
  };
  
  if (token) {
    headers['Authorization'] = `Bearer ${token}`;
  }
  
  const response = await fetch(`${API_BASE_URL}${endpoint}`, {
    method: 'POST',
    headers,
    body: JSON.stringify(data),
  });
  
  if (!response.ok) {
    throw new Error(`HTTP error! status: ${response.status}`);
  }
  
  return response.json();
};

// 通用PUT请求
export const apiPut = async (endpoint, data, token = null) => {
  const headers = {
    'Content-Type': 'application/json',
  };
  
  if (token) {
    headers['Authorization'] = `Bearer ${token}`;
  }
  
  const response = await fetch(`${API_BASE_URL}${endpoint}`, {
    method: 'PUT',
    headers,
    body: JSON.stringify(data),
  });
  
  if (!response.ok) {
    throw new Error(`HTTP error! status: ${response.status}`);
  }
  
  return response.json();
};

// 通用DELETE请求
export const apiDelete = async (endpoint, token = null) => {
  const headers = {
    'Content-Type': 'application/json',
  };
  
  if (token) {
    headers['Authorization'] = `Bearer ${token}`;
  }
  
  const response = await fetch(`${API_BASE_URL}${endpoint}`, {
    method: 'DELETE',
    headers,
  });
  
  if (!response.ok) {
    throw new Error(`HTTP error! status: ${response.status}`);
  }
  
  return response.json();
};

// 文件上传
export const uploadFile = async (file, endpoint, token = null) => {
  const formData = new FormData();
  formData.append('file', file);
  
  const headers = {};
  
  if (token) {
    headers['Authorization'] = `Bearer ${token}`;
  }
  
  const response = await fetch(`${API_BASE_URL}${endpoint}`, {
    method: 'POST',
    headers,
    body: formData,
  });
  
  if (!response.ok) {
    throw new Error(`HTTP error! status: ${response.status}`);
  }
  
  return response.json();
};

// 获取所有公司介绍内容（公开接口）
export const getCompanyContents = async () => {
  try {
    const response = await fetch('/api/admin/company-contents/public/all', {
      headers: {
        'Cache-Control': 'no-cache, no-store, must-revalidate',
        'Pragma': 'no-cache',
        'Expires': '0'
      }
    });
    if (!response.ok) {
      throw new Error(`HTTP error! status: ${response.status}`);
    }
    const data = await response.json();
    if (data.success) {
      // 转换API返回的数据为前端页面期望的格式
      const apiData = data.data;
      
      // 处理图片URL - 确保相对路径正确
      const processImageUrl = (url) => {
        if (!url) return '/api/placeholder/300/300';
        
        // 如果已经是完整URL，直接返回
        if (url.startsWith('http://') || url.startsWith('https://')) {
          return url;
        }
        
        // 处理以/files/开头的路径 - 转换为/uploads/files/
        let processedUrl = url;
        if (url.startsWith('/files/')) {
          processedUrl = '/uploads' + url;
        }
        
        // 如果是相对路径，确保以/开头
        if (processedUrl.startsWith('/uploads/')) {
          // 在生产环境中，图片应该通过Nginx代理访问
          // 在开发环境中，使用完整的后端URL
          if (import.meta.env.PROD) {
            return processedUrl;
          } else {
            return `http://localhost:5000${processedUrl}`;
          }
        }
        
        // 其他情况返回占位符
        return '/api/placeholder/300/300';
      };
      
      // 根据API实际数据结构进行转换
      // 注意：只转换后端实际返回的条目，未返回（已隐藏）的条目设为null
      const transformedData = {
        // 公司简介 - 仅当后端返回时才转换
        introduction: apiData.introduction ? {
          title: apiData.introduction.title || '公司简介',
          content: apiData.introduction?.content?.text || 
            (typeof apiData.introduction?.content === 'string' ? apiData.introduction.content : ''),
          logo_url: apiData.introduction?.content?.logo_url ? processImageUrl(apiData.introduction.content.logo_url) : null,
          image_url: apiData.introduction?.content?.image_url ? processImageUrl(apiData.introduction.content.image_url) : null
        } : null,
        // 发展历程 - 仅当后端返回时才转换
        history: apiData.history ? (apiData.history.content?.timeline || []).map(item => ({
          year: item.year || '',
          title: item.event || '',
          description: item.description || item.event || ''
        })) : null,
        // 团队介绍 - 仅当后端返回时才转换
        team: apiData.team ? (
          apiData.team.content?.items && apiData.team.content.items.length > 0
            ? apiData.team.content.items.filter(item => item.active !== false).map(item => ({
                name: item.name || '',
                position: item.position || '',
                description: item.description || '',
                image: item.image ? processImageUrl(item.image) : '/api/placeholder/300/300'
              }))
            : (apiData.team.content?.members && apiData.team.content.members.length > 0
              ? apiData.team.content.members.filter(item => item.active !== false).map(item => ({
                  name: item.name || '',
                  position: item.position || '',
                  description: item.description || '',
                  image: item.image ? processImageUrl(item.image) : '/api/placeholder/300/300'
                }))
              : (apiData.team.content?.departments || []).map((dept, index) => ({
                  name: dept.name || `部门${index + 1}`,
                  position: dept.name || '',
                  description: dept.description || '',
                  image: '/api/placeholder/300/300'
                })))
        ) : null,
        // 荣誉资质 - 仅当后端返回时才转换
        honors: apiData.honors ? (
          apiData.honors.content?.items && apiData.honors.content.items.length > 0
            ? apiData.honors.content.items.filter(item => item.active !== false).map(item => ({
                title: item.title || '',
                year: item.year || '',
                description: item.description || '',
                category: item.category || 'awards',
                image: item.image ? processImageUrl(item.image) : ''
              }))
            : [
                // 旧格式兼容：从 awards/patents/certifications 数组转换
                ...((apiData.honors.content?.awards || []).map(award => ({
                  title: typeof award === 'string' ? award : (award.title || ''),
                  year: typeof award === 'object' ? (award.year || '') : '',
                  description: typeof award === 'string' ? award : (award.description || ''),
                  image: typeof award === 'object' && award.image ? processImageUrl(award.image) : ''
                }))),
                ...((apiData.honors.content?.patents || []).map(patent => ({
                  title: typeof patent === 'string' ? patent : (patent.title || ''),
                  year: typeof patent === 'object' ? (patent.year || '') : '',
                  description: typeof patent === 'string' ? patent : (patent.description || ''),
                  image: typeof patent === 'object' && patent.image ? processImageUrl(patent.image) : ''
                }))),
                ...((apiData.honors.content?.certifications || []).map(cert => ({
                  title: typeof cert === 'string' ? cert : (cert.title || ''),
                  year: typeof cert === 'object' ? (cert.year || '') : '',
                  description: typeof cert === 'string' ? cert : (cert.description || ''),
                  image: typeof cert === 'object' && cert.image ? processImageUrl(cert.image) : ''
                })))
              ]
        ) : null,
        // 企业文化 - 仅当后端返回时才转换
        values: apiData.values ? {
          mission: apiData.values.content?.mission || '',
          vision: apiData.values.content?.vision || '',
          core_values: (apiData.values.content?.values || []).map((valueItem, index) => {
            let icon = ['🚀', '🤝', '🎯', '💎'][index] || '⭐';
            let name = '';
            let description = '';
            if (typeof valueItem === 'object' && valueItem !== null) {
              // 新格式：{icon, title, description}
              icon = valueItem.icon || icon;
              name = valueItem.title || '';
              description = valueItem.description || '';
            } else if (typeof valueItem === 'string') {
              // 旧格式："创新驱动：xxx"
              const parts = valueItem.split('：');
              if (parts.length >= 2) {
                name = parts[0].trim();
                description = parts.slice(1).join('：').trim();
              } else {
                name = valueItem.trim();
                description = valueItem.trim();
              }
            }
            return {
              icon,
              title: name || '',
              description: description || ''
            };
          }),
          philosophy: apiData.values.content?.philosophy || '',
          rd_philosophy: apiData.values.content?.rd_philosophy || ''
        } : null,
        // 科技创新 - 仅当后端返回时才转换
        innovation: apiData.innovation ? {
          title: apiData.innovation.title || '科技创新',
          description: apiData.innovation.content?.text || 
            (typeof apiData.innovation.content === 'string' ? apiData.innovation.content : 
            apiData.innovation.content?.description || ''),
          features: apiData.innovation.content?.features || [],
          image_url: apiData.innovation.content?.image_url ? processImageUrl(apiData.innovation.content.image_url) : null
        } : null
      };
      
      return transformedData;
    } else {
      throw new Error(data.message || '获取公司介绍内容失败');
    }
  } catch (error) {
    console.error('获取公司介绍内容失败:', error);
    // API 调用失败时所有条目均返回 null，页面仅显示 banner
    return {
      introduction: null,
      history: null,
      team: null,
      honors: null,
      values: null,
      innovation: null
    };
  }
}

// 按类型获取公司介绍内容（公开接口）
export const getCompanyContentByType = async (type) => {
  try {
    const response = await fetch(`/api/admin/company-contents/type/${type}`, {
      headers: {
        'Cache-Control': 'no-cache, no-store, must-revalidate',
        'Pragma': 'no-cache',
        'Expires': '0'
      }
    });
    if (!response.ok) {
      throw new Error(`HTTP error! status: ${response.status}`);
    }
    const data = await response.json();
    if (data.success) {
      return data.data;
    } else {
      throw new Error(data.message || '获取公司介绍内容失败');
    }
  } catch (error) {
    console.error(`获取公司介绍内容失败 (类型: ${type}):`, error);
    return null;
  }
};

// 获取文件列表（公开接口）
export const getFiles = async (params = {}) => {
  try {
    const { category = 'all', search = '', page = 1, limit = 100 } = params;
    
    let url = '/api/downloads';
    const queryParams = [];
    
    if (category && category !== 'all') {
      queryParams.push(`category=${encodeURIComponent(category)}`);
    }
    
    if (search) {
      queryParams.push(`search=${encodeURIComponent(search)}`);
    }
    
    queryParams.push(`page=${page}`);
    queryParams.push(`limit=${limit}`);
    
    if (queryParams.length > 0) {
      url += `?${queryParams.join('&')}`;
    }
    
    const response = await fetch(url, {
      headers: {
        'Cache-Control': 'no-cache, no-store, must-revalidate',
        'Pragma': 'no-cache',
        'Expires': '0'
      }
    });
    
    if (!response.ok) {
      throw new Error(`HTTP error! status: ${response.status}`);
    }
    
    const data = await response.json();
    
    if (data.success) {
      // 转换API返回的数据为前端页面期望的格式
      const apiFiles = data.data.files || [];
      const transformedFiles = apiFiles.map(file => ({
        id: file.id,
        name: file.name,
        displayName: file.displayName,
        category: file.category || 'other',
        description: file.description || '',
        // 使用file.name来提取文件类型，因为后端返回的是name字段而不是filename字段
        fileType: file.name ? file.name.split('.').pop().toLowerCase() : 'pdf',
        fileSize: file.fileSize || '0 MB',
        downloadCount: file.downloadCount || 0,
        updatedAt: file.updatedAt || file.createdAt || new Date().toISOString().split('T')[0],
        downloadUrl: `/api/downloads/${file.id}/download`,
        requiresLogin: file.requireLogin || false
      }));
      
      return {
        files: transformedFiles,
        total: data.data.total || transformedFiles.length,
        page: data.data.page || page,
        totalPages: data.data.totalPages || 1
      };
    } else {
      throw new Error(data.message || '获取文件列表失败');
    }
  } catch (error) {
    console.error('获取文件列表失败:', error);
    // 返回空数组，前端会显示无数据状态
    return {
      files: [],
      total: 0,
      page: 1,
      totalPages: 1
    };
  }
};

// 获取文件分类统计
export const getFileCategories = async () => {
  try {
    const response = await fetch('/api/downloads/categories/list', {
      headers: {
        'Cache-Control': 'no-cache, no-store, must-revalidate',
        'Pragma': 'no-cache',
        'Expires': '0'
      }
    });
    
    if (!response.ok) {
      throw new Error(`HTTP error! status: ${response.status}`);
    }
    
    const data = await response.json();
    
    if (data.success) {
      return data.data || [];
    } else {
      throw new Error(data.message || '获取文件分类失败');
    }
  } catch (error) {
    console.error('获取文件分类失败:', error);
    return ['whitepaper', 'manual', 'driver', 'software', 'product', 'document', 'other'];
  }
};

// ==================== 管理端文件管理 API ====================

// 获取管理端文件列表（需要认证）
export const getAdminFiles = async (params = {}, token) => {
  try {
    const { categoryId = '', search = '', page = 1, limit = 20, fileType = '', sourceModule = '' } = params;
    const queryParams = new URLSearchParams();
    queryParams.append('page', page.toString());
    queryParams.append('limit', limit.toString());
    if (categoryId) queryParams.append('categoryId', categoryId);
    if (search) queryParams.append('search', search);
    if (fileType) queryParams.append('fileType', fileType);
    if (sourceModule) queryParams.append('sourceModule', sourceModule);

    const response = await fetch(`/api/files?${queryParams.toString()}`, {
      headers: {
        'Authorization': `Bearer ${token}`,
        'Cache-Control': 'no-cache'
      }
    });

    if (!response.ok) {
      throw new Error(`HTTP error! status: ${response.status}`);
    }

    const data = await response.json();
    if (data.success) {
      return data.data;
    } else {
      throw new Error(data.message || '获取文件列表失败');
    }
  } catch (error) {
    console.error('获取管理端文件列表失败:', error);
    return { files: [], total: 0, page: 1, totalPages: 1 };
  }
};

// 获取管理端文件分类列表（需要认证）
export const getAdminFileCategories = async (token) => {
  try {
    const response = await fetch('/api/files/categories/list', {
      headers: {
        'Authorization': `Bearer ${token}`,
        'Cache-Control': 'no-cache'
      }
    });

    if (!response.ok) {
      throw new Error(`HTTP error! status: ${response.status}`);
    }

    const data = await response.json();
    if (data.success) {
      return data.data || [];
    }
    return [];
  } catch (error) {
    console.error('获取管理端文件分类失败:', error);
    return [];
  }
};

// 更新文件信息（需要认证）
export const updateFile = async (fileId, updateData, token) => {
  try {
    const response = await fetch(`/api/files/${fileId}`, {
      method: 'PUT',
      headers: {
        'Authorization': `Bearer ${token}`,
        'Content-Type': 'application/json'
      },
      body: JSON.stringify(updateData)
    });

    if (!response.ok) {
      throw new Error(`HTTP error! status: ${response.status}`);
    }

    const data = await response.json();
    return data;
  } catch (error) {
    console.error('更新文件信息失败:', error);
    return { success: false, message: error.message };
  }
};

// 删除文件（需要超级管理员权限）
export const deleteFile = async (fileId, token) => {
  try {
    const response = await fetch(`/api/files/${fileId}`, {
      method: 'DELETE',
      headers: {
        'Authorization': `Bearer ${token}`
      }
    });

    if (!response.ok) {
      throw new Error(`HTTP error! status: ${response.status}`);
    }

    const data = await response.json();
    return data;
  } catch (error) {
    console.error('删除文件失败:', error);
    return { success: false, message: error.message };
  }
};

// 管理端下载文件（需要认证）
export const downloadAdminFile = async (fileId, fileName, token) => {
  try {
    const response = await fetch(`/api/files/${fileId}/download`, {
      headers: {
        'Authorization': `Bearer ${token}`
      }
    });

    if (!response.ok) {
      throw new Error(`HTTP error! status: ${response.status}`);
    }

    const blob = await response.blob();
    const url = window.URL.createObjectURL(blob);
    const a = document.createElement('a');
    a.href = url;
    a.download = fileName;
    document.body.appendChild(a);
    a.click();
    window.URL.revokeObjectURL(url);
    document.body.removeChild(a);
    return { success: true };
  } catch (error) {
    console.error('下载文件失败:', error);
    return { success: false, message: error.message };
  }
};

// 获取产品列表（公开接口）
export const getProducts = async (params = {}) => {
  try {
    const { category = 'all', search = '', page = 1, limit = 12, status = 'published' } = params;
    
    let url = '/api/products';
    const queryParams = [];
    
    // 只获取已发布的产品
    queryParams.push(`status=${status}`);
    
    if (category && category !== 'all') {
      queryParams.push(`category=${encodeURIComponent(category)}`);
    }
    
    if (search) {
      queryParams.push(`search=${encodeURIComponent(search)}`);
    }
    
    queryParams.push(`page=${page}`);
    queryParams.push(`limit=${limit}`);
    
    if (queryParams.length > 0) {
      url += `?${queryParams.join('&')}`;
    }
    
    const response = await fetch(url, {
      headers: {
        'Cache-Control': 'no-cache, no-store, must-revalidate',
        'Pragma': 'no-cache',
        'Expires': '0'
      }
    });
    
    if (!response.ok) {
      throw new Error(`HTTP error! status: ${response.status}`);
    }
    
    const data = await response.json();
    
    if (data.success) {
      // 转换API返回的数据为前端页面期望的格式
      const apiProducts = data.data.products || [];
      const transformedProducts = apiProducts.map(product => {
        // 解析features字段获取分类
        let category = 'industrial';
        try {
          if (product.features && typeof product.features === 'string') {
            const features = JSON.parse(product.features);
            category = features.category || 'industrial';
          } else if (product.features && typeof product.features === 'object') {
            category = product.features.category || 'industrial';
          }
        } catch (e) {
          console.error('解析产品features失败:', e);
        }
        
        // 解析specifications字段获取规格
        let specifications = [];
        try {
          if (product.specifications && typeof product.specifications === 'string') {
            specifications = JSON.parse(product.specifications);
          } else if (product.specifications && typeof product.specifications === 'object') {
            specifications = product.specifications;
          }
        } catch (e) {
          console.error('解析产品specifications失败:', e);
        }
        
        // 解析applications字段获取应用领域
        let applications = [];
        try {
          if (product.applications && typeof product.applications === 'string') {
            applications = JSON.parse(product.applications);
          } else if (product.applications && typeof product.applications === 'object') {
            applications = product.applications;
          }
        } catch (e) {
          console.error('解析产品applications失败:', e);
        }
        
        // 解析price_info字段 - 处理JSON字符串并去除HTML标签
        let priceInfoText = '面议';
        try {
          if (product.price_info) {
            let content = '';
            if (typeof product.price_info === 'string') {
              const priceInfoObj = JSON.parse(product.price_info);
              content = priceInfoObj.content || '面议';
            } else if (typeof product.price_info === 'object') {
              content = product.price_info.content || '面议';
            } else {
              content = product.price_info || '面议';
            }
            
            // 去除HTML标签，只保留纯文本
            priceInfoText = content.replace(/<[^>]*>/g, '').trim();
            if (!priceInfoText) {
              priceInfoText = '面议';
            }
          }
        } catch (e) {
          console.error('解析price_info字段失败:', e);
          // 尝试直接去除HTML标签
          if (typeof product.price_info === 'string') {
            priceInfoText = product.price_info.replace(/<[^>]*>/g, '').trim() || '面议';
          } else {
            priceInfoText = '面议';
          }
        }
        
        // 处理图片路径
        let imageUrl = product.main_image || '/api/placeholder/400/300';
        // 如果图片路径以/uploads、products或files开头，确保它是完整的URL
        if (imageUrl.startsWith('/uploads/') || imageUrl.startsWith('products/') || imageUrl.startsWith('files/')) {
          // 在生产环境中，图片应该通过Nginx代理访问
          // 在开发环境中，使用完整的后端URL
          if (import.meta.env.PROD) {
            // 生产环境：使用相对路径，Nginx会代理到后端
            // 确保路径以/开头
            if (!imageUrl.startsWith('/')) {
              imageUrl = '/' + imageUrl;
            }
          } else {
            // 开发环境：添加完整的基础URL
            // 确保路径以/开头
            if (!imageUrl.startsWith('/')) {
              imageUrl = '/' + imageUrl;
            }
            imageUrl = `http://localhost:5000${imageUrl}`;
          }
        }
        
        return {
          id: product.id,
          name: product.name,
          slug: product.slug || generateSlug(product.name),
          category: category,
          description: product.description || '',
          fullDescription: product.full_description || '',
          priceInfo: priceInfoText,
          image: imageUrl,
          features: product.features || {},
          specifications: specifications,
          applications: applications,
          supportInfo: product.support_info || {},
          status: product.status || 'draft',
          viewCount: product.view_count || 0,
          contactImage: product.contact_image || null,
          publishedAt: product.published_at || product.createdAt,
          createdAt: product.createdAt,
          updatedAt: product.updatedAt
        };
      });
      
      return {
        products: transformedProducts,
        total: data.data.total || transformedProducts.length,
        page: data.data.page || page,
        totalPages: data.data.totalPages || 1
      };
    } else {
      throw new Error(data.message || '获取产品列表失败');
    }
  } catch (error) {
    console.error('获取产品列表失败:', error);
    // 返回空数组，前端会显示无数据状态
    return {
      products: [],
      total: 0,
      page: 1,
      totalPages: 1
    };
  }
};

// 增加产品访问计数（公开接口）
export const incrementProductView = async (id) => {
  try {
    const response = await fetch(`/api/products/${id}/increment-view`, {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
        'Cache-Control': 'no-cache, no-store, must-revalidate',
        'Pragma': 'no-cache',
        'Expires': '0'
      }
    });
    
    if (!response.ok) {
      throw new Error(`HTTP error! status: ${response.status}`);
    }
    
    const data = await response.json();
    
    if (data.success) {
      return data.data;
    } else {
      throw new Error(data.message || '增加访问计数失败');
    }
  } catch (error) {
    console.error('增加产品访问计数失败:', error);
    // 静默失败，不影响用户体验
    return null;
  }
};

// 获取产品详情（公开接口）
export const getProductDetail = async (id) => {
  try {
    const response = await fetch(`/api/products/${id}`, {
      headers: {
        'Cache-Control': 'no-cache, no-store, must-revalidate',
        'Pragma': 'no-cache',
        'Expires': '0'
      }
    });
    
    if (!response.ok) {
      throw new Error(`HTTP error! status: ${response.status}`);
    }
    
    const data = await response.json();
    
    if (data.success) {
      const product = data.data;
      
      // 转换API返回的数据为前端页面期望的格式
      let category = 'industrial';
      let features = '';
      let specifications = '';
      let applications = '';
      let supportInfo = '';
      
      try {
        // 解析features字段 - 提取content字段中的HTML内容
        if (product.features) {
          if (typeof product.features === 'string') {
            const parsed = JSON.parse(product.features);
            features = parsed.content || '';
          } else if (typeof product.features === 'object') {
            features = product.features.content || '';
          }
        }
        
        // 从features中获取category（如果有的话）
        if (product.features && typeof product.features === 'object' && product.features.category) {
          category = product.features.category;
        } else {
          category = 'industrial';
        }
        
        // 解析specifications字段 - 提取content字段中的HTML内容
        if (product.specifications) {
          if (typeof product.specifications === 'string') {
            const parsed = JSON.parse(product.specifications);
            specifications = parsed.content || '';
          } else if (typeof product.specifications === 'object') {
            specifications = product.specifications.content || '';
          }
        }
        
        // 解析applications字段 - 提取content字段中的HTML内容
        if (product.applications) {
          if (typeof product.applications === 'string') {
            const parsed = JSON.parse(product.applications);
            applications = parsed.content || '';
          } else if (typeof product.applications === 'object') {
            applications = product.applications.content || '';
          }
        }
        
        // 解析support_info字段 - 提取content字段中的HTML内容
        if (product.support_info) {
          if (typeof product.support_info === 'string') {
            const parsed = JSON.parse(product.support_info);
            supportInfo = parsed.content || '';
          } else if (typeof product.support_info === 'object') {
            supportInfo = product.support_info.content || '';
          }
        }
      } catch (e) {
        console.error('解析产品字段失败:', e);
      }
      
      // 解析price_info字段 - 提取content字段中的HTML内容
      let priceText = '面议';
      try {
        if (product.price_info) {
          let content = '';
          if (typeof product.price_info === 'string') {
            const priceInfoObj = JSON.parse(product.price_info);
            content = priceInfoObj.content || '面议';
          } else if (typeof product.price_info === 'object') {
            content = product.price_info.content || '面议';
          } else {
            content = product.price_info || '面议';
          }
          
          // 去除HTML标签，只保留纯文本
          priceText = content.replace(/<[^>]*>/g, '').trim();
          if (!priceText) {
            priceText = '面议';
          }
        }
      } catch (e) {
        console.error('解析price_info字段失败:', e);
        // 尝试直接去除HTML标签
        if (typeof product.price_info === 'string') {
          priceText = product.price_info.replace(/<[^>]*>/g, '').trim() || '面议';
        } else {
          priceText = '面议';
        }
      }
      
      // 处理主图片路径
      let imageUrl = product.main_image || '/api/placeholder/800/600';
      // 如果图片路径以/uploads、products或files开头，确保它是完整的URL
      if (imageUrl.startsWith('/uploads/') || imageUrl.startsWith('products/') || imageUrl.startsWith('files/')) {
        // 在生产环境中，图片应该通过Nginx代理访问
        // 在开发环境中，使用完整的后端URL
        if (import.meta.env.PROD) {
          // 生产环境：使用相对路径，Nginx会代理到后端
          // 确保路径以/开头
          if (!imageUrl.startsWith('/')) {
            imageUrl = '/' + imageUrl;
          }
        } else {
          // 开发环境：添加完整的基础URL
          // 确保路径以/开头
          if (!imageUrl.startsWith('/')) {
            imageUrl = '/' + imageUrl;
          }
          imageUrl = `http://localhost:5000${imageUrl}`;
        }
      }
      
      // 创建gallery数组 - 使用后端返回的product.images数据
      let gallery = [];
      if (product.images && Array.isArray(product.images) && product.images.length > 0) {
        // 按display_order排序
        const sortedImages = [...product.images].sort((a, b) => (a.display_order || 0) - (b.display_order || 0));
        
        gallery = sortedImages.map(img => {
          let imgUrl = img.image_url || '/api/placeholder/800/600';
          // 处理图片路径
          if (imgUrl.startsWith('/uploads/') || imgUrl.startsWith('products/') || imgUrl.startsWith('files/')) {
            if (import.meta.env.PROD) {
              // 确保路径以/开头
              if (!imgUrl.startsWith('/')) {
                imgUrl = '/' + imgUrl;
              }
            } else {
              // 确保路径以/开头
              if (!imgUrl.startsWith('/')) {
                imgUrl = '/' + imgUrl;
              }
              imgUrl = `http://localhost:5000${imgUrl}`;
            }
          }
          return imgUrl;
        });
      } else {
        // 如果没有图片，使用主图片和占位符
        gallery = [
          imageUrl,
          '/api/placeholder/800/600',
          '/api/placeholder/800/600'
        ];
      }
      
      // 处理features - 直接使用HTML字符串
      let featuresHtml = features || '';
      
      // 处理applications - 直接使用HTML字符串
      let applicationsHtml = applications || '';
      
      // 处理specifications - 直接使用HTML字符串
      let specificationsHtml = specifications || '';
      
      // 处理support_info - 直接使用HTML字符串
      let supportInfoHtml = supportInfo || '';

      // 返回转换后的产品详情数据
      return {
        id: product.id,
        name: product.name,
        slug: product.slug || generateSlug(product.name),
        category: category,
        description: product.description || '',
        fullDescription: product.full_description || '',
        priceInfo: priceText,
        image: imageUrl,
        gallery: gallery,
        features: featuresHtml, // 使用HTML字符串
        specifications: specificationsHtml, // 使用HTML字符串
        applications: applicationsHtml, // 使用HTML字符串
        supportInfo: supportInfoHtml, // 使用HTML字符串
        contactImage: product.contact_image || null,
        status: product.status || 'draft',
        publishedAt: product.published_at || product.createdAt,
        createdAt: product.createdAt,
        updatedAt: product.updatedAt,
        viewCount: product.view_count || 0 // 添加访问计数
      };
    } else {
      throw new Error(data.message || '获取产品详情失败');
    }
  } catch (error) {
    console.error('获取产品详情失败:', error);
    // 返回默认的产品详情数据
    return {
      id: id,
      name: '产品名称',
      slug: 'product-name',
      category: 'industrial',
      description: '产品描述',
      fullDescription: '详细的产品描述信息',
      priceInfo: '面议',
      image: '/api/placeholder/800/600',
      gallery: [
        '/api/placeholder/800/600',
        '/api/placeholder/800/600',
        '/api/placeholder/800/600'
      ],
      features: ['高性能多核处理器', '支持多种工业通信协议', '工业级防护设计', '远程监控与管理', '可扩展I/O接口', '实时操作系统'],
      specifications: {
        processor: 'ARM Cortex-A53 四核 1.5GHz',
        memory: '2GB DDR4',
        storage: '16GB eMMC',
        interfaces: '4x Ethernet, 4x USB, 2x RS485, 1x RS232',
        power: 'DC 24V ±20%',
        operatingTemperature: '-20°C ~ 70°C',
        dimensions: '200mm × 150mm × 50mm',
        weight: '1.2kg',
        certifications: 'CE, FCC, RoHS'
      },
      applications: ['工业自动化控制', '智能制造系统', '设备监控', '数据采集', '过程控制'],
      supportInfo: {
        warranty: '3年质保',
        technicalSupport: '7x24小时技术支持',
        documentation: '完整的技术文档和用户手册',
        training: '提供现场培训和远程指导'
      },
      viewCount: 0
    };
  }
};

// 获取轮播图列表（公开接口）
export const getCarousels = async () => {
  try {
    const response = await fetch('/api/carousel', {
      headers: {
        'Cache-Control': 'no-cache, no-store, must-revalidate',
        'Pragma': 'no-cache',
        'Expires': '0'
      }
    });
    
    if (!response.ok) {
      throw new Error(`HTTP error! status: ${response.status}`);
    }
    
    const data = await response.json();
    
    if (data.success) {
      // 转换API返回的数据为前端组件期望的格式
      const apiCarousels = data.data || [];
      const transformedCarousels = apiCarousels.map(carousel => {
        // 确保图片路径正确 - 如果是相对路径，添加完整URL
        let imageUrl = carousel.image_url || '/api/placeholder/1920/800';
        // 如果图片路径以/uploads开头，确保它是完整的URL
        if (imageUrl.startsWith('/uploads/')) {
          // 在生产环境中，图片应该通过Nginx代理访问
          // 在开发环境中，使用完整的后端URL
          if (import.meta.env.PROD) {
            // 生产环境：使用相对路径，Nginx会代理到后端
            imageUrl = imageUrl;
          } else {
            // 开发环境：添加完整的基础URL
            imageUrl = `http://localhost:5000${imageUrl}`;
          }
        }
        
        return {
          id: carousel.id,
          type: carousel.media_type || 'image',
          src: imageUrl,
          alt: carousel.title || '轮播图',
          title: carousel.title || '',
          description: carousel.description || '',
          link: carousel.target_url || '/',
          video_url: carousel.video_url || '',
          poster: imageUrl,
          display_order: carousel.display_order || 0,
          is_active: carousel.is_active !== undefined ? carousel.is_active : true,
          auto_play_duration: carousel.auto_play_duration || 5000
        };
      });
      
      return transformedCarousels;
    } else {
      throw new Error(data.message || '获取轮播图失败');
    }
  } catch (error) {
    console.error('获取轮播图失败:', error);
    // 返回默认的轮播图数据
    return [
      {
        id: 1,
        type: 'image',
        src: '/api/placeholder/1920/800',
        alt: '科技解决方案展示',
        title: '创新科技解决方案',
        description: '为企业提供全方位的数字化转型服务',
        link: '/products'
      },
      {
        id: 2,
        type: 'image',
        src: '/api/placeholder/1920/800',
        alt: '产品展示',
        title: '专业产品系列',
        description: '涵盖硬件、软件及定制化解决方案',
        link: '/products'
      },
      {
        id: 3,
        type: 'video',
        src: '/api/placeholder/video.mp4',
        poster: '/api/placeholder/1920/800',
        alt: '公司介绍视频',
        title: '关于摩恒科技',
        description: '了解我们的发展历程和企业文化',
        link: '/company'
      }
    ];
  }
};

// 辅助函数：生成slug
function generateSlug(name) {
  return name
    .toLowerCase()
    .replace(/[^\w\u4e00-\u9fa5]+/g, '-')
    .replace(/^-+|-+$/g, '')
    .replace(/--+/g, '-');
}
